import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import { getDynamicData } from 'utils/bolt/dynamicData';

export default class HeaderExpanded extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount?.();

		await this.loadCustomData(await getDynamicData('landing'));
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}

		this.dynamicData = {
			socials: (dynamicData?.header?.socials || []).reduce((acc, sItem, index) => {
				acc[sItem.icon] = { destination: sItem.path, order: index };
				return acc;
			}, {}),
		};
		this.forceUpdate();
	}

}